<section
    class="group flex justify-between"
    data-testid="sidebar-community"
    [ngClass]="{
        'text-text-primary': selected(),
        'text-text-mid-contrast hover:text-text focus:text-text': !selected(),
    }"
>
    <a
        #communityButton
        class="flex w-full items-center overflow-hidden rounded-4 pl-8 text-left"
        [attr.aria-current]="selected() ? 'page' : null"
        [routerLink]="communityHref()"
    >
        <interacta-icon
            class="mr-8 size-24 shrink-0"
            [icon]="'community'"
            [matTooltip]="community().name | currentLanguage"
            [matTooltipDisabled]="expanded()"
            [matTooltipPosition]="'right'"
        />
        <span
            class="line-clamp-2 grow typo-xs-bold wrap-break-word transition-opacity duration-500"
            [ngClass]="{ 'opacity-0': !expanded(), 'opacity-100': expanded() }"
            >{{ community().name }}</span
        >
    </a>
    @if (pinVisible() && expanded()) {
        <button
            #pinButton
            data-testid="sidebar-community-pin"
            type="button"
            [attr.aria-label]="
                (pinned() ? 'SIDEBAR.UNPIN_COMMUNITY' : 'SIDEBAR.PIN_COMMUNITY')
                    | translate
            "
            [attr.aria-pressed]="pinned()"
            [ngClass]="{
                'opacity-0 group-hover:opacity-100 focus:opacity-100':
                    !pinned(),
                'opacity-100': pinned(),
            }"
            (click)="pinClicked()"
        >
            <interacta-icon
                class="block size-20 transition-transform duration-300"
                [icon]="'pin-filled'"
                [ngClass]="{
                    'rotate-45 hover:rotate-0': !pinned(),
                    'rotate-0 hover:rotate-45': pinned(),
                }"
            />
        </button>
    }
</section>
